import { DayOfWeek, DeadlineRuleType, DeadlineRule } from '@/types';
import { debugLog } from './environment';

export const DEFAULT_PICKUP_TIME = '10:00';
export const DEFAULT_DELIVERY_TIME = '16:00';

/**
 * 曜日の日本語ラベルを取得
 */
export const getDayOfWeekLabel = (day: DayOfWeek): string => {
  const labels = {
    [DayOfWeek.SUNDAY]: '日曜日',
    [DayOfWeek.MONDAY]: '月曜日',
    [DayOfWeek.TUESDAY]: '火曜日',
    [DayOfWeek.WEDNESDAY]: '水曜日',
    [DayOfWeek.THURSDAY]: '木曜日',
    [DayOfWeek.FRIDAY]: '金曜日',
    [DayOfWeek.SATURDAY]: '土曜日',
  };
  return labels[day];
};

/**
 * 曜日の短縮ラベルを取得
 */
export const getDayOfWeekShortLabel = (day: DayOfWeek): string => {
  const labels = {
    [DayOfWeek.SUNDAY]: '日',
    [DayOfWeek.MONDAY]: '月',
    [DayOfWeek.TUESDAY]: '火',
    [DayOfWeek.WEDNESDAY]: '水',
    [DayOfWeek.THURSDAY]: '木',
    [DayOfWeek.FRIDAY]: '金',
    [DayOfWeek.SATURDAY]: '土',
  };
  return labels[day];
};

/**
 * 時間文字列を HH:mm 形式に正規化
 */
export const normalizeTime = (time: string): string => {
  if (!time) return '';
  // HH:mm:ss や その他の形式を HH:mm に統一
  return time.substring(0, 5);
};

/**
 * 月曜日から始まる曜日順の配列を取得
 */
export const getWeekdayOrder = (): DayOfWeek[] => [
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
  DayOfWeek.SATURDAY,
  DayOfWeek.SUNDAY,
];

/**
 * 曜日・ルール種別の組み合わせキーを生成
 */
export const getRuleMapKey = (dayOfWeek: DayOfWeek, ruleType: DeadlineRuleType): string => {
  return `${dayOfWeek}-${ruleType}`;
};

/**
 * 締切ルールをマップに変換
 */
export const createRuleMap = (rules: DeadlineRule[]): Map<string, DeadlineRule> => {
  const map = new Map<string, DeadlineRule>();
  rules.forEach(rule => {
    const key = getRuleMapKey(rule.dayOfWeek, rule.ruleType);
    map.set(key, rule);
  });
  return map;
};

/**
 * デフォルトのルールデータを生成
 */
export const createDefaultRuleData = (ruleType: DeadlineRuleType) => ({
  deadlineTime: ruleType === DeadlineRuleType.PICKUP ? DEFAULT_PICKUP_TIME : DEFAULT_DELIVERY_TIME,
  isActive: true,
});

/**
 * ルール種別の日本語表示名を取得
 */
export const getRuleTypeName = (ruleType: DeadlineRuleType): string => {
  return ruleType === DeadlineRuleType.PICKUP ? '引取' : '搬入';
};

/**
 * 開発環境でのみログを出力
 */
export const devLog = (message: string, data?: any): void => {
  debugLog(message, data);
};

/**
 * 曜日が有効かどうか判定（引取または搬入ルールが存在するか）
 */
export const isDayEnabled = (pickupRule: any, deliveryRule: any): boolean => {
  return Boolean(pickupRule || deliveryRule);
};
